export const asCurrencyString = (value: number): string => {
  return (
    value?.toLocaleString('en-GB', {
      style: 'currency',
      currency: 'GBP',
    }) || '£0.00'
  );
};
